import { Api } from "@/common/api/Api";
import { axiosInstance } from "@/plugins/axios";
import { AxiosInstance } from "axios";

export class ConfigurationApi extends Api {
  constructor(axios: AxiosInstance) {
    super("configuration", axios);
  }
}

export const configurationApi = new ConfigurationApi(axiosInstance);
